import React from "react";
import {
    AppLayout,
    Header,
    SideNavigation,
    Container,
    ContentLayout,
    Cards,
    Box,
    Link,
    SpaceBetween,
    BreadcrumbGroup
} from '@cloudscape-design/components';
import CFAQ from "./Cfaq";
import SFAQ from "./Sfaq";
import { NavigationSide  } from "./Navigation";
function Prfaq() {
    return (
        <AppLayout
          navigation={<NavigationSide />}
          content={<MainContent />}
          header={<PageHeader />}
          contentType="dashboard"
        />
    );
  }
  function Navigation() {
    return (
      <SideNavigation
        header={{ text: 'AWS Eloquence', href: '/' }}
        items={[
          { type: 'link', text: 'Learn More', href: '/learnmore' },
          { type: 'link', text: 'Get Started', href: '/getstarted' },
          { type: 'link', text: 'My Meetings', href: '/meetings'},
          { type: 'link', text: 'Meet the Team', href: '/meettheteam'},
          { type: 'link', text: 'Architecture Diagram', href: '/architecture'},
          { type: 'divider' },
          { type: 'link', text: 'Documentation', href: '/documentation' },
        ]}
      />
    );
  }
  
  function MainContent() {
      //const navigate = useNavigate();
      return (
        <>
        <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Documentation", href: "/documentation" },
          { text: "PRFAQ", href: "/prfaq" }
        ]}
        ariaLabel="Breadcrumbs"
      />
      <br></br>
        <ContentLayout
          defaultPadding  
          // headerBackgroundStyle="linear-gradient(135deg, rgb(71, 17, 118) 3%, rgb(131, 57, 157) 44%, rgb(149, 85, 182) 69%, rgb(145, 134, 215) 94%)"
          headerVariant="high-contrast"
          maxContentWidth={2000}
          disableOverlap
          header={
          <SpaceBetween size="m">
            <Header variant="h1" description="Read our Press Release">AWS Eloquence PRFAQ</Header>
          </SpaceBetween>
          }
        >
          <br></br>
          <SpaceBetween size="l">
            
          
          <Container>
            <h3>AWS Launches AI Powered Presentation Coach for Solution Architects</h3>
            <p style={{ wordSpacing: '0.1rem', lineHeight: '1.3', textIndent: '2em' }}>Amazon Web Services launches an internal tool that enables Solution Architects to receive automated feedback on their customer conversations, which allows Solution Architects to refine their speaking skills and provide better support to customers. 
                Austin, Texas – September 3, 2024 – Amazon Web Service (AWS) today announced the launch of AWS Eloquence, a new AI powered presentation coach for Solution Architects. AWS Eloquence is designed to be invited to a Chime call through a Chrome extension and can provide constructive feedback to Solution Architects. Eloquence will provide a presentation score based on factors such as speaking rate, AWS key terminology usage, filler words, and other best practices.
                Delivering effective presentations is a crucial part of the Solution Architect role. However, finding available peers or managers to practice with can be a challenge, especially for new hires or those who prefer to refine their presentations in private. Given the subjectivity of customer conversations, feedback provided can be scattered and conflicting. This feedback does not give Solution Architects an accurate baseline on whether they are improving or not. 
                AWS Eloquence offers an automated solution for coaching Solution Architects as they prepare for conversations with customers. 
                </p>
                <p style={{ wordSpacing: '0.1rem', lineHeight: '1.3', textIndent: '2em', marginTop: '.05rem'  }}>
              AWS Eloquence is trained on AWSome Builder conversations, a program designed to prepare new Solution Architects for field work with mock customer scenarios and presentations. Solution Architects are now able to stream their meetings on Chime to AWS Eloquence, which will automatically analyze their conversation. The AWS Eloquence agent compares the Solution Architect’s conversation to successful AWSome Builder conversations. After analyzing the conversation, the Solution Architect can view a summary of their conversation on a web dashboard containing granular feedback on their messaging, tone, technical depth, and so on. Solution Architects now have an automated solution to receive personalized feedback on their customer conversations.  
                “AWS Eloquence is a valuable tool that will help us drive better customer experiences across our AWS customer-facing teams," said Greg Pearson, VP of AWS Global Sales. "By providing Solution Architects with feedback on their communication skills and AWS messaging, we can empower them to have more effective dialogues that address customer needs. Ultimately, this will lead to higher customer satisfaction, reduced escalations, and stronger brand loyalty for AWS. We're committed to investing in innovative AI-powered solution that upskill our workforce and optimize our customer interactions.” 
                Solution Architects can invite the Eloquence agent to their meetings with a chrome extension. After the meeting, the Solution Architect can view metrics and feedback associated with their meeting on the dashboard. The dashboard contains metrics such as an overall score out of 100, AWS terminology usage, filler words used, and so on. 
                </p>
                <p style={{ wordSpacing: '0.1rem', lineHeight: '1.3', textIndent: '2em', marginTop: '.05rem'  }}>
                Additionally, the dashboard offers actionable advice for the Solution Architect to implement to improve their rating. Solution Architects will be able to see trends associated with their feedback over time, which enables them to understand their improvement over time. The dashboard offers a centralized way to schedule the feedback agent and view call feedback granularly or over time. 
                “It’s difficult to get an accurate baseline on your customer conversation skills,” said Max Miller, a Senior Solution Architect at AWS. “Due to the subjective nature of customer conversations, feedback is conflicting when speaking with other Solution Architects. AWS Eloquence has been a game-changer for receiving concrete, actionable feedback on my customer conversations. The analytics offer insight on subtle, but important, social cues that human evaluators could miss. Overall, AWS Eloquence enables me to refine and improve my customer conversation skills in an automated fashion. It helps me become a better Solution Architect.” 
                </p>
          </Container>

          <Container><CFAQ></CFAQ></Container>

          <Container><SFAQ></SFAQ></Container>

          </SpaceBetween>
      </ContentLayout>
      </>
    );
  }
  function PageHeader() {
    return (
      <Header
        variant="h1"
        actions={
          <div>
            {/* Add any header actions here */}
          </div>
        }
      >
        My Application
      </Header>
    );
  }
  export default Prfaq;
